import React, { Component } from 'react';
import { Button, Form } from 'react-bootstrap';

class RequestRow extends Component {
  getStatusStyle(status) {
    if (status === 'Accepted') {
      return { color: 'green', fontWeight: 'bold' };
    } else if (status === 'Rejected') {
      return { color: 'red', fontWeight: 'bold' };
    } else {
      return { color: 'orange', fontWeight: 'bold' };
    }
  }

  render() {
    const { request, toggleSelectRequest, isSelected } = this.props;

    return (
      <tr>
        <td>
          <Form.Check
            type="checkbox"
            checked={isSelected}
            onChange={() => toggleSelectRequest(request.id)}
          />
        </td>
        <td>{request.productName}</td>
        <td>{request.buyer}</td>
        <td>{request.requestDate}</td>
        <td style={this.getStatusStyle(request.status)}>{request.status}</td>
        <td>
          {request.status === 'Pending' ? (
            <>
              <Button variant="success" style={{ marginRight: '10px' }}>
                Accepter
              </Button>
              <Button variant="danger">
                Rejeter
              </Button>
            </>
          ) : (
            <span>Action prise</span>
          )}
        </td>
      </tr>
    );
  }
}

export default RequestRow;
